import { getEssentialTerms, getPremierTerms, getUserTerms } from '@api/api'
import { TermsDetails } from '@api/api.types'
import { useStoreState } from '@store/index'
import { queryOptions } from '@tanstack/react-query'

export const GENERAL_TERMS = 'GENERAL_TERMS_QUERY'

export const userTermsQueryOptions = queryOptions({
  queryKey: [GENERAL_TERMS],
  queryFn: async () => {
    const { data } = await getUserTerms()
    return data
  },
})

export type UserTermsProps<TData = TermsDetails[]> = {
  select?: (data: TermsDetails[]) => TData
  isPayCardAccount?: boolean
}

export const WALLET_TERMS = 'WALLET_TERMS_QUERY'

export const walletTermsQueryOptions = <TData = TermsDetails[]>({
  isPayCardAccount,
  select,
}: UserTermsProps<TData>) =>
  queryOptions({
    queryKey: [WALLET_TERMS, isPayCardAccount],
    queryFn: async () => {
      const { data } = isPayCardAccount
        ? await getEssentialTerms()
        : await getPremierTerms()
      return data
    },
    select,
  })

export const useWalletTermsQueryOptions = <TData = TermsDetails[]>(
  select?: UserTermsProps<TData>['select']
) => {
  const { essentialFlow } = useStoreState(state => state.onboarding)
  return walletTermsQueryOptions({
    isPayCardAccount: essentialFlow,
    select,
  })
}
